import TaxPayerAssetsForm from "../components/tax-payer/TaxPayerAssetsForm";

const TaxPayerAssetsPage = () => {
  return (
    <>
      <TaxPayerAssetsForm />
    </>
  );
};

export default TaxPayerAssetsPage;
